import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, toast } from '@grandvisionhq/common';
import { CheckboxWithLabel } from '@grandvisionhq/forms';
import { StockIndicator } from '@grandvisionhq/inventory';
import { withIntl } from '@grandvisionhq/state';
import { getEyeLabel } from '../../../utils.js';
import { SelectContainer } from './components/SelectContainer/SelectContainer.js';
import { SelectWrapper } from './components/SelectWrapper/SelectWrapper.js';
import { getMaxSelectableQuantity } from '../../../../utils/get-max-selectable-quantity.js';
import { SelectQuantityContainer } from '../../../SelectQuantity/SelectQuantityContainer.js';

class Prescription extends (React.Component) {
    componentDidMount() {
        const { attributes , products  } = this.props;
        const initialFilters = this.getInitialFilters(attributes);
        this.setState({
            activeFilters: initialFilters,
            attributes
        });
        if (products.length === 1) {
            this.getSkuByAttributes(initialFilters);
        }
    }
    componentDidUpdate(prevProps) {
        var ref, ref1;
        if (this.props.isCLBBTabSelected && prevProps.isCLBBTabSelected !== this.props.isCLBBTabSelected) {
            // Reset back to 1 as quantity should not be updated in CLBB subscription lenses
            this.props.onQuantityChange(1);
            this.props.onSelection(true);
        }
        if (((ref = this.props.products) === null || ref === void 0 ? void 0 : ref.length) === 1 && (prevProps === null || prevProps === void 0 ? void 0 : (ref1 = prevProps.products) === null || ref1 === void 0 ? void 0 : ref1.length) === 0) {
            let initialFilters = this.state.activeFilters;
            if (!initialFilters || !Object.keys(initialFilters).length) {
                initialFilters = this.getInitialFilters(this.props.attributes);
            }
            this.getSkuByAttributes(initialFilters);
        }
    }
    renderStockIndicator() {
        const { availableQuantity , isStockEnabled  } = this.props;
        if (!isStockEnabled || !this.state.foundProduct) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(StockIndicator, {
            stockCount: availableQuantity,
            allowBackOrder: this.state.foundProduct.attributes.allowBackOrder,
            // Setting channelAvailability to ONLINE since CL's are always orderable
            channelAvailability: 'ONLINE'
        });
    }
    render() {
        const { isActive , availableQuantity , maxOrderableQuantity , id , currentBreakpoint , intl , hasError , quantity , className , isCLBBTabSelected ,  } = this.props;
        const eyeLabel = getEyeLabel(intl, id);
        const isMobile = currentBreakpoint === MediaQuery.BreakpointName.PHONE || currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT;
        const { foundProduct , attributes  } = this.state;
        const maxSelectableQuantity = getMaxSelectableQuantity({
            allowBackOrder: foundProduct === null || foundProduct === void 0 ? void 0 : foundProduct.attributes.allowBackOrder,
            availableQuantity,
            maxOrderableQuantity
        });
        const selectElementValues = {
            currentBreakpoint,
            handleAttributeChange: this.handleAttributeChange,
            activeFilters: this.state.activeFilters,
            attributes,
            id,
            hasError,
            isActive,
            foundProduct: this.state.foundProduct
        };
        const checkboxClass = classnames('prescription__checkbox', {
            'prescription__checkbox--indented': id === 'right' && !isMobile,
            'prescription__checkbox--selectable': !isCLBBTabSelected
        });
        const stockIndicatorClass = classnames('prescription__stock-indicator', {
            'prescription__stock-indicator--indented': id === 'right' && !isMobile
        });
        return /*#__PURE__*/ React.createElement("div", {
            className: `prescription ${className}`,
            "data-t": this.props['data-t']
        }, !isCLBBTabSelected && /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
            label: eyeLabel,
            className: checkboxClass,
            checkboxClassName: "prescription__checkbox-view",
            value: id,
            checked: !!isActive,
            onChange: (event)=>{
                this.props.onSelection(event.checked);
            },
            "data-t": "prescription-checkbox"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "select-container"
        }, /*#__PURE__*/ React.createElement(SelectContainer, swcHelpers.extends({}, selectElementValues)), !isCLBBTabSelected && /*#__PURE__*/ React.createElement(SelectWrapper, null, /*#__PURE__*/ React.createElement(SelectQuantityContainer, {
            className: "prescription__dropdown",
            parentId: id,
            onChange: this.props.onQuantityChange,
            showLabel: id === 'right' || isMobile,
            lensesPerBox: this.props.packSize,
            maxSelectableQuantity: maxSelectableQuantity,
            selectedQuantity: quantity,
            isDisabled: Boolean(!isActive || foundProduct && !foundProduct.attributes.allowBackOrder && !availableQuantity)
        }))), !isCLBBTabSelected && /*#__PURE__*/ React.createElement("div", {
            className: stockIndicatorClass
        }, this.renderStockIndicator()));
    }
    constructor(...args){
        super(...args);
        this.state = {
            activeFilters: {},
            attributes: {}
        };
        this.getInitialFilters = (filterAttributes)=>{
            const initialFilters = {};
            for (const attribute of Object.keys(filterAttributes)){
                const currentAttribute = Array.from(filterAttributes[attribute].values);
                if (currentAttribute.length === 1 && attribute !== 'packageQuantity') {
                    initialFilters[attribute] = currentAttribute[0];
                    // TODO fix the missing types in here some other time (been there for 1+ year now)
                    this.props.handleLensBundleChange(this.props.id, attribute, currentAttribute[0]);
                }
            }
            return initialFilters;
        };
        this.handleAttributeChange = (key, value)=>{
            if (value) {
                const newFilter = swcHelpers.objectSpread({}, this.state.activeFilters, {
                    [key]: value
                });
                const attribute = this.state.attributes[key];
                if (!attribute) {
                    return;
                }
                attribute.selected = value;
                this.setState({
                    activeFilters: newFilter,
                    attributes: swcHelpers.objectSpread({}, this.state.attributes, {
                        [key]: attribute
                    })
                }, ()=>{
                    key !== 'packageQuantity' && this.props.handleLensBundleChange(this.props.id, key, value);
                    // Omit packageQuantity just like it is removed from filter.
                    const length = Object.keys(this.state.attributes).length;
                    const attributeLength = this.state.attributes.packageQuantity ? length - 1 : length;
                    if (Object.keys(newFilter).length === attributeLength) {
                        this.getSkuByAttributes(newFilter);
                    }
                });
            } else {
                this.setFoundProduct(undefined);
            }
        };
        this.setFoundProduct = (product)=>{
            this.setState({
                foundProduct: product
            });
            this.props.onFoundProduct(product);
        };
        this.getSkuByAttributes = (filters)=>{
            const enrichedFilters = swcHelpers.objectSpread({}, filters, {
                packageQuantity: this.props.packSize
            });
            const foundProduct = this.props.products.find(({ attributes  })=>{
                let valid = true;
                for (const filter of Object.keys(enrichedFilters)){
                    const value = enrichedFilters[filter];
                    valid = filter in attributes && attributes[filter] === value;
                    if (!valid) {
                        break;
                    }
                }
                return valid;
            });
            if (foundProduct) {
                this.setFoundProduct(foundProduct);
            } else {
                toast.failed(`products.contactLenses.prescription.alert.${this.props.id}Eye`);
            }
        };
    }
}
Prescription.defaultProps = {
    isActive: true
};
var Prescription$1 = withIntl(MediaQuery.WithBreakpoints(Prescription));

export { Prescription, Prescription$1 as default };
//# sourceMappingURL=Prescription.js.map
